// extracted by mini-css-extract-plugin
export var archive = "product-card-module--archive--2db4c";
export var available = "product-card-module--available--0b843";
export var details = "product-card-module--details--366d8";
export var hoverImage = "product-card-module--hoverImage--9166a";
export var imageContainer = "product-card-module--imageContainer--5f8c1";
export var inner = "product-card-module--inner--fbaf7";
export var mainImage = "product-card-module--mainImage--9d251";
export var price = "product-card-module--price--4b008";
export var productCard = "product-card-module--productCard--c7db8";
export var title = "product-card-module--title--b6637";